export const ExpertsImageParams = {
    imgLS0:"Experts__PraveenRajaram.png",
    imgLS1:"Experts__SaraswathiSwaminathan.png",
    imgL0:"Experts__DhirenSinam.png",
    imgL1:"Experts__JagadeeshaHulikal.png",
    imgL2:"Experts__JaganathanThiyagarajan.png",
    imgL3:"Experts__RamapavaniPoruri.png",
    // imgL4:"Experts__SateeshNalluri.png",
    imgL4:"Experts__ShyamBahadur.png",
    imgL5:"Experts__SrinivasSeetharamaiah.png",
    imgL6:"Experts__VaradharajanBalakrishnan.png",
    imgL7:"Experts__Vinitha.png",
    imgSME0:"Experts__AbdulSattarShaik.png",
    imgSME1:"Experts__AbhijeetKhurd.png",
    imgSME2:"Experts__AbhijitPattnaikNew.png",
    imgSME3:"Experts__AdinarayanaTalla.png",
    // imgSME3:"Experts__AiswaryaMurali.png",
    imgSME4:"Experts__AmitaMishra.png",
    imgSME5:"Experts__AnushaRameshNew.png",
    // imgSME4:"Experts__AnjayChakravarty.png",
    imgSME6:"Experts__ArnaKumari.png",
    imgSME7:"Experts__AthreshP.png",
    imgSME8:"Experts__AyushiShrivastavNew.png",
    imgSME9:"Experts__AZHARUDDIN.png",
    imgSME10:"Experts__BasappaHallur.png",
    imgSME11:"Experts__ChaudhurySourya.png",
    imgSME12:"Experts__DevPawar.png",
    imgSME13:"Experts__DilipKumar.png",
    imgSME14:"Experts__Karthikeyan.png",
    imgSME15:"Experts__KudratAli.png",
    imgSME16:"Experts__KUMARSRINIVAS.png",
    imgSME17:"Experts__LavanyaVenkatesh.png",
    imgSME18:"Experts__LaxmiAhuja.png",
    imgSME19:"Experts__LokeshManjunath.png",
    imgSME20:"Experts__ManeruAshok.png",
    imgSME21:"Experts__Meenakshi.png",
    imgSME22:"Experts__PanchamiShettyNew.png",
    imgSME23:"Experts__PRAKASHARUMUGAM.png",
    imgSME24:"Experts__PremPratik.png",
    imgSME25:"Experts__PriitamTajne.png",
    imgSME26:"Experts__RamShekar.png",
    imgSME27:"Experts__RAVALAVENKAIAH.png",
    imgSME28:"Experts__SaiSivaPrasadLankaNew.png",
    // imgSME24:"Experts__SachinChandrashekar.png",
    imgSME29:"Experts__SATHYAMARIAPPAN.png",
    imgSME30:"Experts__SoumyadiptaDas.png",
    imgSME31:"Experts__SridharChalla.png",
    // imgSME28:"Experts__SuryaPrakash.png",
    imgSME32:"Experts__SusmitaPanigrahi.png",
    imgSME33:"Experts__SwapnaliPatil.png",
    imgSME34:"Experts__VSAIPRAKASH.png",
    imgSME35:"Experts__Vikram.png",
    // imgSME36:"Experts__Vinitha.png",
};

// export const ExpertsImageParams = {
//   imgLS0:"Experts__PraveenRajaram.png",
//   imgLS1:"Experts__SaraswathiSwaminathan.png",

//   imgL0:"Experts__DhirenSinam.png",
//   imgL1:"Experts__JagadeeshaHulikal.png",
//   imgL2:"Experts__JaganathanThiyagarajan.png",
//   imgL3:"Experts__RamapavaniPoruri.png",
  
//   imgL4:"Experts__ShyamBahadur.png",
//   imgL5:"Experts__VaradharajanBalakrishnan.png",

  
//   imgSME0: "Experts__AbdulSattarShaik.png",
//   imgSME1: "Experts__AbhijeetKhurd.png",
//   imgSME2: "Experts__AdinarayanaTalla.png",
//   imgSME3: "Experts__AmitaMishra.png",          
//   imgSME4: "Experts__ArnaKumari.png",
//   imgSME5: "Experts__AthreshP.png",
//   imgSME6: "Experts__AZHARUDDIN.png",
//   imgSME7: "Experts__BasappaHallur.png",
//   imgSME8: "Experts__ChaudhurySourya.png",
//   imgSME9: "Experts__DevPawar.png",
//   imgSME10: "Experts__DilipKumar.png",
//   imgSME11: "Experts__Karthikeyan.png",
//   imgSME12: "Experts__KudratAli.png",
//   imgSME13: "Experts__KUMARSRINIVAS.png",
//   imgSME14: "Experts__LavanyaVenkatesh.png",
//   imgSME15: "Experts__LaxmiAhuja.png",
//   imgSME16: "Experts__LokeshManjunath.png",
//   imgSME17: "Experts__ManeruAshok.png",
//   imgSME18: "Experts__Meenakshi.png",
//   imgSME19: "Experts__PRAKASHARUMUGAM.png",
//   imgSME20: "Experts__PremPratik.png",
//   imgSME21: "Experts__PriitamTajne.png",
//   imgSME22: "Experts__RamShekar.png",
//   imgSME23: "Experts__RAVALAVENKAIAH.png",
//   // removed 26 + 30
//   imgSME24: "Experts__SATHYAMARIAPPAN.png",
//   imgSME25: "Experts__SoumyadiptaDas.png",
//   imgSME26: "Experts__SridharChalla.png",
//   imgSME27: "Experts__SusmitaPanigrahi.png",
//   imgSME28: "Experts__SwapnaliPatil.png",
//   imgSME29: "Experts__VSAIPRAKASH.png",
//   imgSME30: "Experts__Vikram.png",
//   imgSME31: "Experts__Vinitha.png",

  
//   imgSME32: "Experts__SaiSivaPrasadLanka.png",
//   imgSME33: "Experts__AyushiShrivastav.png",
//   imgSME34: "Experts__AbhijitPattnaik.png",
//   imgSME35: "Experts__AnushaRamesh.png",
//   imgSME36: "Experts__PanchamiShetty.png"
// };